export function shippingClock(epoch) {
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Istanbul', hourCycle: 'h23', hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date(epoch));
  const get = name => Number(parts.find(part => part.type === name).value);
  const elapsed = get('hour') * 3600 + get('minute') * 60 + get('second');
  const open = elapsed < 36000;
  const remaining = open ? 36000 - elapsed : 86400 - elapsed + 36000;
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  return { open, remaining, text: [hours, minutes, seconds].map(value => String(value).padStart(2, '0')).join(':') };
}

if (typeof document !== 'undefined') {
  const banners = [...document.querySelectorAll('[data-shipping-clock]')];
  if (banners.length) {
    const epoch = Number(banners[0].dataset.serverTime) * 1000 || Date.now();
    const start = performance.now();
    const update = () => {
      const state = shippingClock(epoch + performance.now() - start);
      for (const banner of banners) {
        const timer = banner.querySelector('[data-shipping-timer]');
        const status = banner.querySelector('[data-shipping-status]');
        timer.textContent = state.text;
        timer.hidden = false;
        timer.dateTime = `PT${state.remaining}S`;
        const [hours, minutes, seconds] = state.text.split(':');
        for (const [name, value] of Object.entries({ hours, minutes, seconds })) {
          const digit = banner.querySelector(`[data-shipping-${name}]`);
          if (digit && digit.textContent !== value) digit.textContent = value;
        }
        const label = state.open ? banner.dataset.before : banner.dataset.after;
        if (status.textContent !== label) status.textContent = label;
        banner.dataset.cutoffOpen = String(state.open);
      }
    };
    update();
    const interval = setInterval(() => { if (!document.hidden) update(); }, 1000);
    document.addEventListener('visibilitychange', update);
    window.addEventListener('pageshow', update);
    window.addEventListener('pagehide', event => { if (!event.persisted) clearInterval(interval); });
  }
}
